const fin = {
  id: 1,
  type: "flashingFin",
  label: 'Add Flashing Fin 1 1/2" (A)',
};

const finAlum = {
  id: 1,
  type: "flashingFin",
  label: 'Add Flashing Fin 1 9/16" (E)',
};

const finAlumBifold = {
  id: 1,
  type: "flashingFin",
  label: 'Add Flashing Fin 1 1/2" (F)',
};

const options = [
  {
    id: 1,
    type: "flashingFinConfig",
    label: 'Standard 1" Setback',
  },
  {
    id: 2,
    type: "flashingFinConfig",
    label: "Custom Setback",
  },
];

export { fin, options, finAlum, finAlumBifold };
